<template>
  <div>
    <CRow>
      <CCol col="12" lg="12">
        <CCard>
          <CCardHeader>
            <strong>Επιθεωρητής:</strong> {{ title }}
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab title="Γενικές Πληροφορίες" active>
                <CCard>
                  <CCardBody>
                    <CDataTable 
                      striped 
                      small 
                      fixed
                      :items="items" 
                      :fields="fields"
                    >
                      <template slot="value" slot-scope="data">
                        <td><strong>{{data.item.value}}</strong></td>
                      </template>
                    </CDataTable>
                  </CCardBody>
                </CCard>
              </CTab>
              <CTab title="EA / NACE">
                <CCard>
                  <CCardBody>
                    <CDataTable
                      :items="filteredItems"
                      :fields="service_subcategory_fields"
                      :items-per-page="10"
                      pagination
                      column-filter
                      table-filter
                      hover
                      :loading="loading"
                      sorter
                    >
                    <template #service-filter>
                      <div class="selectFilter">
                        <CSelect
                          :options="servicesOptions"
                          :value.sync="selectedIsoOption"
                        />
                      </div>
                    </template>
                    <template #service="{item}">
                      <td>
                        {{ item.service }}
                      </td>
                    </template>
                    <template #inspector_role="{item}">
                      <td>
                        {{ item.inspector_role }}
                      </td>
                    </template>
                    <template #active_since="{item}">
                      <td>
                        {{ item.active_since }}
                      </td>
                    </template>
                    <template #activeEA-filter>
                      <div class="selectFilter">
                        <CSelect
                          :options="statusOptionsActiveEA"
                          :value.sync="selectedOptionActiveEA"
                        />
                      </div>
                    </template>
                    <template #activeEA="{item}">
                      <td>
                        <CBadge :color="getBadge(item.pivot.activeEA)">{{ getBadgeText(item.pivot.activeEA) }}</CBadge>
                      </td>
                    </template>
                    <template #edit="{item}">
                      <td>
                        <CButton color="primary" @click="editSubcategory(item.id)">Επεξεργασία</CButton>
                      </td>
                    </template>
                    <template #show="{item}">
                      <td>
                        <CButton color="primary" @click="showSubcategory(item.id)">Προβολή</CButton>
                      </td>
                    </template>
                  </CDataTable>
                  </CCardBody>
                </CCard>
              </CTab>
            </CTabs>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Inspector',
  data: () => {
    return {
      items: [],
      roles: [],
      service_subcategory: [],
      services_raw: '',
      selectedOptionActiveEA: 'Καμία επιλογή',
      statusOptionsActiveEA: ['Καμία επιλογή', 'Ενεργός', 'Ανενεργός'],
      selectedIsoOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      loading: true,
      title: '',
      fields: [
        {key: 'key', label: 'Πεδίο'},
        {key: 'value', label: 'Τιμή'},
      ],
      service_subcategory_fields: [
        {
          key: 'name', 
          label: 'ΕΑ / NACE', 
          sorter: true, 
          filter: true
        },
        {
          key: 'service', 
          label: 'Πρότυπο ISO', 
          sorter: true, 
          filter: true
        },
        {
          key: 'inspector_role', 
          label: 'Ρόλος', 
          sorter: true, 
          filter: true
        },
        {
          key: 'activeEA', 
          label: 'Κατάσταση', 
          sorter: false, 
          filter: true
        },
        {
          key: 'active_since', 
          label: 'Ενεργός από', 
          sorter: false, 
          filter: true
        },
        { 
          key: 'edit', 
          label: '', 
          sorter: false, 
          filter: false
        },
        { 
          key: 'show', 
          label: '', 
          sorter: false, 
          filter: false
        },
      ]
    }
  },
  computed: {
    filteredItems() {
      if (this.selectedOptionActiveEA == "Καμία επιλογή" && this.selectedIsoOption == "Καμία επιλογή") {
        return this.service_subcategory;
      }
      return this.service_subcategory.filter(item => {
        const status = item.pivot.activeEA == 1 ? 'Ενεργός' : 'Ανενεργός'
        const services = item.service;

        if (this.selectedOptionActiveEA == "Καμία επιλογή") {
          return services == this.selectedIsoOption;
        }

        if (this.selectedIsoOption == "Καμία επιλογή") {
          return status == this.selectedOptionActiveEA;
        }

        return status == this.selectedOptionActiveEA && services == this.selectedIsoOption;
      })
      // if (this.selectedOptionActiveEA == "Καμία επιλογή") {
      //   return this.service_subcategory;
      // }
      // return this.service_subcategory.filter(item => {
      //   const status = item.pivot.activeEA == 1 ? 'Ενεργός' : 'Ανενεργός'
      //   return status == this.selectedOptionActiveEA
      // })
    }
  },
  methods: {
    getInspectorData (id) {
      const inspector = inspectorsData.find((inspector, index) => index + 1 == id)
      const inspectorDetails = inspector ? Object.entries(inspector) : [['id', 'Not found']]
      return inspectorDetails.map(([key, value]) => { return { key, value } })
    },
    getService(subcategory) {
      var temp = this.services_raw.find((item) => { if (item.id == subcategory) { return item; } });

      return temp.name;
    },
    goBack() {
      this.$router.go(-1)
    },
    getBadge (status) {
      return status === 1 ? 'success' : 'secondary'
    },
    getBadgeText (status) {
      return status === 1 ? 'Ενεργός' : 'Ανενεργός'
    },
    subcategoryLink(id) {
      return `/services/subcategory/${id.toString()}`
    },
    showSubcategory(id) {
      const subcategoryLink = this.subcategoryLink(id);
      this.$router.push({path: subcategoryLink});
    },
    editSubcategoryLink(id) {
      return `/services/subcategory/${id.toString()}/edit`
    },
    editSubcategory(id) {
      const subcategoryLink = this.editSubcategoryLink(id);
      this.$router.push({path: subcategoryLink});
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/inspectors/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.services_raw = response.data.inspector.services;
      let roles = response.data.roles;

      const ser_items = Object.entries(response.data.inspector).map(([key, value]) => {return {key: key, value: value}});
      const keys = ["name", "activity", "afm", "services", "comments", "active", "service_subcategories"];
      self.items = ser_items.filter((t) => keys.includes(t.key));
      self.title = self.items.find((t) => t.key == "name").value;

      self.items = self.items.map((item) => {
        if (item.key == "name") {
          item.key = 'Ονοματεπώνυμο:'
        } else if (item.key == "activity") {
          item.key = 'Δραστηριότητα:'  
        } else if (item.key == "afm") {
          item.key = 'ΑΦΜ:'  
        } else if (item.key == "comments") {
          item.key = 'Σχόλια:'
        } else if (item.key == "services") {
          item.value = item.value.map((t) => {return t.name;}).join(", ");
          item.key = 'Πρότυπο ISO:'
        } else if (item.key == "service_subcategories") {
          self.service_subcategory = ser_items.find((t) => t.key == "service_subcategories");
          self.service_subcategory = self.service_subcategory.value;
          self.ea = self.service_subcategory.map((item) => item.name);
          item.key = "EA/NACE:";
          item.value = self.ea.join(", ");
        } else if (item.key == "active") {
          let tempRole = self.items.find((t) => t.key == "active").value;
          if (tempRole == '1') {
            item.value = 'Ενεργός';
            item.key = 'Κατάσταση:'
          } else if (tempRole == '0') {
            item.value = 'Ανενεργός'
            item.key = 'Κατάσταση:'
          }
        }

        return item;
      });

      // var tempRoleID = response.data.inspector.service_subcategories.map((item) => {
      //   self.statusT = self.service_subcategory.map((item) => item.pivot.status);
      //   self.statusNameT = self.service_subcategory.map((item) => item.inspector_roles.role); 
      //   self.eaNameT = self.service_subcategory.map((item) => item.name);
      //   return item;
      // });

      self.service_subcategory = self.service_subcategory.map((item) => {
        item.service = self.getService(item.pivot.service_id);
        item.inspector_role = roles.find(role => role.id === item.pivot.status).role; 
        item.active_since = item.pivot.active_since;
        return item;
      });

        axios.get('/api/services/list?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
          self.services = response.data

          self.servicesOptions = ['Καμία επιλογή', ...self.services];
          self.selectedIsoOption = self.servicesOptions[0];

        }).catch(function (error) {
          console.log(error);
          self.loading = false;
          // self.$router.push({ path: '/login' });
        });

      self.loading = false;
    }).catch(function (error) {
      console.log(error);
      self.loading = false;
      // self.$router.push({ path: '/login' });
    });
  }
}

</script>
